export default __webpack_public_path__ + "static/media/pot2.9b383a50.jpg";